import { selectUserPromotionStatus } from '../../../../selectors/user/userPrimary.selector';
import { StateType } from '../../../../states';
import { PromotionStatuses } from '../../../../types/promotions';
import { Selector } from '../../../../types/selectors';
import { GRNotificationState } from '../../types/notification';
import { GROperationUserStatuses } from '../../types/user';

const emptyObj = {};

export const selectGRUserState = (state: StateType) => state.gr.user ?? emptyObj;

export const selectGRUserBetslips = (state: StateType) => selectGRUserState(state)?.betslips ?? emptyObj;

export const selectGRUserStatus = (state: StateType) => selectGRUserState(state)?.status;

export const selectGRUserRoundId = (state: StateType) => selectGRUserState(state)?.round;

export const selectGRUserProgress = (state: StateType) => selectGRUserState(state)?.progress;

const emptyNotificationsArray: Array<GRNotificationState> = [];
export const selectGRUserNotifications = (state: StateType) =>
  selectGRUserState(state)?.notifications ?? emptyNotificationsArray;

export const selectIsGRUserOptIn: Selector<boolean> = (state: StateType) =>
  selectGRUserStatus(state) === GROperationUserStatuses.IN;

export const selectIsGRUserForbidden: Selector<boolean> = (state: StateType) =>
  selectGRUserStatus(state) === GROperationUserStatuses.EXCLUDED ||
  selectUserPromotionStatus(state) !== PromotionStatuses.DEFAULT;
